export default __webpack_public_path__ + "static/media/marko_m.fdaa45a0.jpg";